import {
  CRUD_PACKAGE,
  DROPDOWN_CITY,
  DROPDOWN_STATE,
  DROPDOWN_ZIPCODE,
} from "../../data/APIEndpoints";
import axios from "../AxiosInstance";

const getDropdownCity = async (state) => {
  try {
    const response = await axios.get(`${DROPDOWN_CITY}?state=${state}`);
    if (response.status === 200) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: "Error fetching city",
      error: error,
    };
  }
};

const getDropdownState = async () => {
  try {
    const response = await axios.get(DROPDOWN_STATE);
    if (response.status === 200) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: "Error fetching state",
      error: error,
    };
  }
};

const getDropdownZipCode = async (state, city) => {
  try {
    const response = await axios.get(
      `${DROPDOWN_ZIPCODE}?city=${city}&state=${state}`
    );
    if (response.status === 200) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: "Error fetching zipcode",
      error: error,
    };
  }
};

const postCreatePackage = async (packageDetails) => {
  try {
    const response = await axios.post(CRUD_PACKAGE, packageDetails);
    if (response.status === 201) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: "Package creation Failed",
      error: error,
    };
  }
};

const editPackage = async (packageDetails) => {
  try {
    const response = await axios.put(CRUD_PACKAGE, packageDetails);
    if (response.status === 200) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: "Failed to update package",
      error: error,
    };
  }
};

const getPackageById = async (jobId) => {
  try {
    const packageId = isNaN(jobId) ? `?jobCode=${jobId}` : `?jobId=${jobId}`;
    const response = await axios.get(`${CRUD_PACKAGE}${packageId}`);
    if (response.status === 200) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: "Error fetching city",
      error: error,
    };
  }
};

const packageCrud = {
  getDropdownCity,
  getDropdownState,
  getDropdownZipCode,
  postCreatePackage,
  editPackage,
  getPackageById,
};

export default packageCrud;
